//TODO - this may possibly be unnecessary and ripped out when cookie.storage.js comes out. Also, these files are called in app-template and all other front-end apps in app/configuration/storage.configuration.js

define('evicommon/storage/abstract.storage',['require','exports','module','underscore','backbone','marionette'],function(require, exports, module) {
  //prettier-ignore
  var _        = require('underscore'),
      Backbone = require('backbone'),
      Mn       = require('marionette');

  var AbstractStorage = Backbone.Model.extend({
    constructor: function(options) {
      this.options = _.extend({}, _.result(this, 'options'));
      this.attributes = {};
      this.changed = {};
      this.once(
        'load',
        function() {
          this.on('change', this.save, this);
        },
        this
      );
      this.initialize.apply(this, arguments);
    },

    initialize: function() {},

    triggerMethod: Mn.triggerMethod,

    load: function(defaults) {
      this.triggerMethod('load', defaults);
      return this;
    },

    save: function() {
      this.triggerMethod('save');
      return this;
    },
  });

  module.exports = AbstractStorage;
});

